import { render } from "./ShowOrganization.vue?vue&type=template&id=43fff7e5"
import script from "./ShowOrganization.vue?vue&type=script&lang=js"
export * from "./ShowOrganization.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/agro_exporter/certifications/providers/show_organization.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Fcertifications%2Fproviders%2FShowOrganization.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/organization_certification.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fagro_exporter%2Fcertifications%2Fproviders%2FShowOrganization.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__